import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Card, Flex } from 'pcln-design-system'
import { themeGet } from 'styled-system'

const StyledCard = styled(Card)`
  position: relative;
  padding: ${themeGet('space.3')}px ${themeGet('space.4')}px;
  background-color: ${(props) => props.backgroundColor || 'white'};
  border: none;
  border-radius: 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 2px 0;
  cursor: pointer;
`

function DropdownContent({ backgroundColor, children }) {
  return (
    <StyledCard backgroundColor={backgroundColor}>
      <Flex flexDirection='column'>{children}</Flex>
    </StyledCard>
  )
}

DropdownContent.displayName = 'DropdownContent'

DropdownContent.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
}

export default memo(DropdownContent)
